<template>
    <card-skeleton class-name="ma-0 pa-1" :is-loading="isLoading">
        <v-card-title class="text-h4 font-weight-bold primary-text-color pb-2 d-flex align-center">
            <div class="w-100">
                <span class="align-self-center">{{ subject }}</span>
                <span id="issue-id" class="font-weight-regular ml-2">#{{ id }}</span>
                <div v-if="createdAt" class="d-flex mt-2">
                    <svg-icon :icon="calendar" alt="calendar" />
                    <span class="ml-1 font-weight-regular text-size-md">{{ formatTimestamp(createdAt) }}</span>
                </div>
            </div>
            <div class="ml-auto align-self-baseline">
                <v-chip size="small" :class="{ ['text-size-xs text-white bg-' + color]: true }">
                    {{ text }}
                </v-chip>
            </div>
        </v-card-title>
        <v-divider thickness="4" class="grey lighten-2 rounded-sm"></v-divider>
        <v-card-item v-if="!isDemand && issueCategory?.value">
            <v-card-text class="pa-0">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                        <v-chip v-if="isDemand" color="warning" size="large" class="ml-4" variant="tonal">
                            {{ demandCategories() }}
                        </v-chip>
                    </div>
                    <div class="text-subtitle-1 text-medium-emphasis mt-2">
                        {{ issueCategory?.value }}
                    </div>
                </div>
            </v-card-text>
        </v-card-item>
    </card-skeleton>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import { formatTimestamp } from '@/helpers';
import { firstCharToLower } from '@/helpers/StringHelpers';
import { IIssueDetailsHeader } from '../../types';
import { getIssueSubCategories } from '@/features/issuesPage/helpers';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import calendar from '@/assets/calendar.svg';

const { t } = useI18n();

const props = defineProps<IIssueDetailsHeader>();

const demandCategories = () => {
    if (!props.issueSubCategories) return null;
    const getKeys = getIssueSubCategories(props.issueSubCategories);
    return getKeys.map(key => t(`classifiers.demandCategory.${firstCharToLower(key)}`)).join(', ');
};
</script>
